import './CreatableSelectArea.scss';
import clsx from 'clsx';
import React, { ReactElement, ReactNode } from 'react';
import { ControlProps, GroupBase, components } from 'react-select';
import CreatableSelect, { CreatableProps } from 'react-select/creatable';

export type CreatableSelectAreaProps<
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = CreatableProps<Option, IsMulti, Group> & {
  icon?: ReactNode;
  invalid?: boolean;
};

const Control = <
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(props: ControlProps<Option, IsMulti, Group> & {
  selectProps: CreatableSelectAreaProps<Option, IsMulti, Group>;
}): ReactElement => {
  const { children, selectProps } = props;

  return (
    <components.Control {...props}>
      <div className="bp-creatable-select-area__icon">
        {selectProps.icon}
      </div>

      {children}
    </components.Control>
  );
};

export const CreatableSelectArea = <
  Option = unknown,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({ invalid, ...props }: CreatableSelectAreaProps<Option, IsMulti, Group>): ReactElement => (
  <CreatableSelect
    className={clsx({
      'bp-creatable-select-area': true,
      'bp-creatable-select-area--invalid': invalid,
    })}
    classNamePrefix="bp-react-select"
    closeMenuOnSelect={true}
    isSearchable={true}
    isClearable={true}
    components={{
      DropdownIndicator: null,
      Control: Control,
    }}
    styles={{
      control: (base) => ({
        ...base,
        boxShadow: 'none',
      }),
    }}
    menuShouldScrollIntoView={false}
    {...props}
  />
);
